import {
  CurrentPageProvider,
  IPageContent,
  IPageLayout,
} from "../../contexts/router";
import { useRouter } from "../../hooks/router";
import { BottomSheet } from "./bottom-sheet";
import { FullPage } from "./full-page";
import { Popup } from "./popup";
import style from "./style.css";
import { Fragment, h } from "preact";
import { popPageAction } from "../../actions/router";
import { Info } from "../info";
import { WalletWrapper } from "../context-wrappers/wallet-wrapper";
import { RewardWrapper } from "../context-wrappers/reward-wrapper";
import { ProgramWrapper } from "../context-wrappers/program-wrapper";
import { ProgramNudgeWrapper } from "../context-wrappers/program-nudge-wrapper";
import { useErrorBoundary } from "preact/hooks";
import { ErrorWrapper } from "../context-wrappers/error-wrapper";
import { ClientGuardWrapper } from "../context-wrappers/client-guard-wrapper";

export const Portal = () => {
  const [state, dispatch] = useRouter();
  let pageStack: JSX.Element[] = [];

  function pop() {
    dispatch(popPageAction());
  }

  if (state && state.allIds.length) {
    for (let i = state.allIds.length - 1; i >= 0; i--) {
      const id = state.allIds[i];
      let isActive = false;
      if (i == state.allIds.length - 1) {
        isActive = true;
      }
      pageStack.unshift(
        <CurrentPageProvider
          page={state.byId[id]}
          isActive={i === state.allIds.length - 1}
        >
          <PageFrame
            key={id}
            layout={state.byId[id].layout}
            startClose={state.byId[id].startClose}
            zIndex={1000 + i}
            onClose={pop}
            isActive={isActive}
          >
            <PageContent content={state.byId[id].content} />
            <ClientGuardWrapper />
          </PageFrame>
        </CurrentPageProvider>
      );
      if (state.byId[id].hidePreviousPages) break;
    }
  }

  return <Fragment>{pageStack}</Fragment>;
};

export const PageFrame = (props: {
  children: any;
  layout: IPageLayout;
  zIndex: number;
  startClose: boolean | undefined;
  isActive: boolean;
  onClose: () => void;
}) => {
  let fragment: JSX.Element | null = null;
  if (props.layout.type_id === "FULL_PAGE") {
    fragment = (
      <FullPage
        isActive={props.isActive}
        onClose={props.onClose}
        startClose={props.startClose}
        {...props.layout}
      >
        {props.children}
      </FullPage>
    );
  } else if (props.layout.type_id === "BOTTOM_SHEET") {
    fragment = (
      <BottomSheet
        isActive={props.isActive}
        onClose={props.onClose}
        startClose={props.startClose}
        {...props.layout}
      >
        {props.children}
      </BottomSheet>
    );
  } else if (props.layout.type_id === "POPUP") {
    fragment = (
      <Popup
        isActive={props.isActive}
        onClose={props.onClose}
        startClose={props.startClose}
        {...props.layout}
      >
        {props.children}
      </Popup>
    );
  }
  if (fragment) {
    return (
      <div className={style.pageFrame} style={{ zIndex: props.zIndex }}>
        {fragment}
      </div>
    );
  } else {
    return (
      <ErrorWrapper
      status={{
        state: "LOAD_ERROR",
        message: "page type, not found",
      }}
    />
    );
  }
};

export const PageContent = (props: { content: IPageContent }) => {
  const [error, resetError] = useErrorBoundary();
  if (error) {
    console.log(error);
    return (
      <ErrorWrapper
        status={{
          state: "LOAD_ERROR",
          message: "error occurred, please try again later",
        }}
      />
    );
  }
  if (props.content.type_id === "WALLET_WRAPPER") {
    return <WalletWrapper {...props.content} />;
  } else if (props.content.type_id === "REWARD_WRAPPER") {
    return <RewardWrapper {...props.content} />;
  } else if (props.content.type_id === "PROGRAM_WRAPPER") {
    return <ProgramWrapper {...props.content} />;
  } else if (props.content.type_id === "PROGRAM_NUDGE_WRAPPER") {
    return <ProgramNudgeWrapper {...props.content} />;
  }
};
